<div class="row mt-5">
    <div class="col-8">
        <form [formGroup]="selectForm" (ngSubmit)="selectCollection()" autocomplete="off" ngNativeValidate>
            <div class="row ">
                <div class="col-md-12 mb-3">
                    <div class="row g-3 align-items-center">
                        <div class="col-auto">
                            <label for="inputPassword6" class="label">Select Collection</label>
                        </div>
                        <div class="col-4">
                            <div class="input-group input-group-sm">
                                <select id="inputState" class="form-select" formControlName="selectdb">
                                <option value="" disabled selected>--</option>
                                <option [value]="item"  *ngFor="let item of select_arr">{{item | uppercase}}</option>
                            </select>
                            </div>
                        </div>

                        <div class="col-4">
                            <button type="submit" class="btn btn-themecolor btn-sm btn-block rounded-pill">
                               Get Data
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </form>
    </div>

</div>
<div *ngIf="cargando" class="row mt-4 animated fadeIn">
    <div class="col">
        <div class="alert alert-info text-center" role="alert">
            <strong>Loading</strong>
            <br>
            <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
            <br>
            <span class="mt-2">Please wait</span>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-8" class="text-right">
        <app-kite-grid
          [columnDefs]="columnDefs"
          [rowData]="gridData"
          [totalRecords]="gridData.length"
          [pageSize]="gridData.length || 1">
        </app-kite-grid>
    </div>
</div>